// extracted by mini-css-extract-plugin
module.exports = {"container":"DatePicker_container__2XA5K","labelContainer":"DatePicker_labelContainer__f2o0l","label":"DatePicker_label__3ly5v","icon":"DatePicker_icon__1d5FY"};